import React, { useState } from "react";
import Header from "../../../Components/Header";
import SingleSignOnSideBar from "../../../Components/SingleSignOnSideBar";
import PartnerPayoutMaster from "./PartnerPayoutMaster";
import PartnerCommissionModule from "../PartnerPayoutModule/PartnerCommissionModule";

function PartnerPayoutWrapper(props) {
    const [checkTab, setCheckTab] = useState("payout")

    return (
        <div>
            <Header title={props.title} portal={""} />
            <SingleSignOnSideBar />
            <main id="main-content">
                <div className="tab-content card-box" id="mainTabContent">
                    <div
                        className="tab-pane fade show active"
                        id="team"
                        role="tabpanel"
                        aria-labelledby="team-tab"
                    >
                        <div className="secondary-tabs">
                            <div className="card-tab-list">
                                <ul className="nav page-tabs" id="mainTab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link active"
                                            id="admin-tab"
                                            data-toggle="tab"
                                            data-target="#admin"
                                            type="button"
                                            role="tab"
                                            aria-controls="admin"
                                            aria-selected="true"
                                            onClick={()=> setCheckTab("payout")}
                                        >
                                            Partner Payout Master
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation"  >
                                        <button
                                            className="nav-link"
                                            id="rejection-tab"
                                            data-toggle="tab"
                                            data-target="#rejection"
                                            type="button"
                                            role="tab"
                                            aria-controls="rejection"
                                            aria-selected="false"
                                            onClick={()=> setCheckTab("comission")}
                                        >
                                            Partner Commission Module
                                        </button>
                                    </li>
                                   
                                </ul>
                            </div>
                            <div className="card-tab-details">
                                <div
                                    className="tab-content dashboard-tab-content"
                                    id="nav-tabContent"
                                >
                                    <div
                                        className="tab-pane fade show active"
                                        id="admin"
                                        role="tabpanel"
                                        aria-labelledby="nav-admin-tab"
                                    >
                                        <PartnerPayoutMaster checkTab={checkTab}/>
                                    </div>
                                    <div
                                        className="tab-pane fade show "
                                        id="rejection"
                                        role="tabpanel"
                                        aria-labelledby="nav-rejection-tab"
                                    >
                                        <PartnerCommissionModule checkTab={checkTab}/>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default PartnerPayoutWrapper;
